import { forwardRef } from 'react';
import { ButtonViewProps } from './ViewProps';
import { useViewProps } from './useViewProps';

export const ButtonView = forwardRef<HTMLButtonElement, ButtonViewProps>(
  function ButtonViewWithRef(props, ref) {
    const { children, testID, type = 'button', role, ...rest } = useViewProps(props);

    return (
      <button ref={ref} data-testid={testID} type={type} role={role} {...rest}>
        {children}
      </button>
    );
  },
);
